import React from 'react';
export default function MyTickets() {
    return <div className="st-container py-20"><h1 className="text-3xl font-display">Mis Tickets (Próximamente)</h1></div>;
}